"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "diffDay", {
  enumerable: true,
  get: function get() {
    return _diffDay["default"];
  }
});
Object.defineProperty(exports, "addHours", {
  enumerable: true,
  get: function get() {
    return _addHours["default"];
  }
});
Object.defineProperty(exports, "addDays", {
  enumerable: true,
  get: function get() {
    return _addDays["default"];
  }
});
Object.defineProperty(exports, "getToday", {
  enumerable: true,
  get: function get() {
    return _getToday["default"];
  }
});
Object.defineProperty(exports, "getMonthsBetween", {
  enumerable: true,
  get: function get() {
    return _getMonthsBetween["default"];
  }
});
Object.defineProperty(exports, "dateToTimestamp", {
  enumerable: true,
  get: function get() {
    return _dateToTimestamp["default"];
  }
});
exports.WEEK_IN_MS = exports.MULTIUSE_END = exports.MULTIUSE_START = exports.NO_END = exports.NO_START = void 0;

var _diffDay = _interopRequireDefault(require("./diffDay"));

var _addHours = _interopRequireDefault(require("./addHours"));

var _addDays = _interopRequireDefault(require("./addDays"));

var _getToday = _interopRequireDefault(require("./getToday"));

var _getMonthsBetween = _interopRequireDefault(require("./getMonthsBetween"));

var _dateToTimestamp = _interopRequireDefault(require("./dateToTimestamp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NO_START = '0001-01-01T00:00:00Z';
exports.NO_START = NO_START;
var NO_END = '9999-12-31T00:00:00Z';
exports.NO_END = NO_END;
var MULTIUSE_START = '1500-01-01T00:00:00Z';
exports.MULTIUSE_START = MULTIUSE_START;
var MULTIUSE_END = '2500-01-01T00:00:00Z';
exports.MULTIUSE_END = MULTIUSE_END;
var WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000;
exports.WEEK_IN_MS = WEEK_IN_MS;